/**
 * Elo-style Skill: show at most one decimal; drop trailing ".0" for whole values.
 */
export function formatSkillLevel(raw) {
  if (raw == null || raw === "") return "0";
  const n = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(n)) return "0";
  const rounded = Math.round(n * 10) / 10;
  const s = rounded.toFixed(1);
  return s.endsWith(".0") ? s.slice(0, -2) : s;
}

/** Signed delta for compact inline text (+12.3, -4.1, 0). */
export function formatSkillChangeInline(raw) {
  if (raw == null || raw === "") return "—";
  const n = typeof raw === "number" ? raw : Number(raw);
  if (!Number.isFinite(n)) return "—";
  const rounded = Math.round(n * 10) / 10;
  if (rounded === 0) return "0";
  const absStr = formatSkillLevel(Math.abs(rounded));
  if (rounded > 0) return "+" + absStr;
  return "-" + absStr;
}

/** Match detail row: "+12.3 points" */
export function formatSkillDeltaPoints(n) {
  const s = formatSkillChangeInline(n);
  if (s === "—") return "—";
  return `${s} points`;
}
